/* Copy da página de detalhe da empresa (ADR-0811): trilha, mensagem de não-encontrada e os
   rótulos das 5 abas. `CompanyDetailHeader` e as abas (`CompanyOverviewTab`/`CompanyMembersTab`/
   `CompanySubscriptionTab`/`CompanyPackagesTab`/`CompanyAuditTab`) são componentes externos —
   fora do escopo desta área. "Packages" fica igual nos dois idiomas — mesma convenção do
   catálogo de packs (produto). */
import type { Bilingual } from '../bilingual.js';
import { useBilingual } from '../locale-provider.js';

interface CompanyDetailContent {
  readonly breadcrumbAriaLabel: string;
  readonly companiesLabel: string;
  readonly companyFallbackLabel: string;
  readonly notFoundMessage: string;
  readonly tabs: {
    readonly overview: string;
    readonly members: string;
    readonly subscription: string;
    readonly packages: string;
    readonly audit: string;
  };
}

const COMPANY_DETAIL_CONTENT: Bilingual<CompanyDetailContent> = {
  'pt-BR': {
    breadcrumbAriaLabel: 'Trilha',
    companiesLabel: 'Empresas',
    companyFallbackLabel: 'Empresa',
    notFoundMessage: 'Empresa não encontrada ou indisponível.',
    tabs: {
      overview: 'Visão geral',
      members: 'Membros',
      subscription: 'Assinatura',
      packages: 'Packages',
      audit: 'Auditoria',
    },
  },
  'en-US': {
    breadcrumbAriaLabel: 'Breadcrumb',
    companiesLabel: 'Companies',
    companyFallbackLabel: 'Company',
    notFoundMessage: 'Company not found or unavailable.',
    tabs: {
      overview: 'Overview',
      members: 'Members',
      subscription: 'Subscription',
      packages: 'Packages',
      audit: 'Audit',
    },
  },
};

export const useCompanyDetailContent = (): CompanyDetailContent =>
  useBilingual(COMPANY_DETAIL_CONTENT);
